<template>
    <div class="flex w-full thunderbite__content">
        <iframe
            v-if="src"
            :src="src"
            id="iframe-content"
            class="thunderbite__iframe"
            :style="iFrameStyle"
        />
        <div class="thunderbite__copy">
            <div class="thunderbite__copy-heading">{{ $t('Spin the wheel of Super Luck every day!') }}</div>
            <p class="thunderbite__copy-text">
                <a
                    :href="config.superSpin.superSpinTermsUrl"
                    target="_blank"
                    class="thunderbite__copy-link"
                >
                    {{ $t('Regulations here') }}
                </a>
                {{ $t('Make sure you check the marketing agreements to be able to benefit from bonuses') }}
            </p>
        </div>
    </div>
</template>

<script>
    import { getConfig } from '@superbet-group/web.lib.config';
    import {
        isMobileLayout,
        isMobileDevice,
    } from '@superbet-group/web.lib.vue-utilities';
    import {
        mapGetters,
        mapActions,
    } from 'vuex';

    import { RouteName } from '@app/router/constants/RouteName';
    import { shellLocalConfig } from '@src/config/shell/localConfig';
    import FreeToPlayService from '@src/core/services/freeToPlay/FreeToPlayService';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
    import { featureFlagService } from '@superbet-group/web.lib.flags';

    function getIFrameOrigin(src) {
        return new URL(src).origin;
    }

    function getSuperSpinUrl(isExperimentActive) {
        const config = getConfig()?.superSpin || {};
        return (isExperimentActive ? config.superSpinUrlV2 : config.superSpinUrl) || '';
    }

    function parseSuperSpinMessage(message = '') {
        const [key, value] = message.split(':');
        const update = {};
        if (key && value) {
            update[key] = value;
        }
        return update;
    }

    export default {
        data() {
            return {
                iFrameHeight: 920,
                generatedSrc: '',
                superSpinExperiment: false, // SuperSpin default fallback
            };
        },
        async created() {
            this.loginModal = {
                code: modalCodes.login,
                afterClose: this.setMessageModal,
            };

            if (!this.user) {
                this.setLoginModal();
            }
            this.messageListener = window.addEventListener('message', this.messageEventListener);
            this.superSpinExperiment = await featureFlagService.getFeatureValue('super-spin-ro-experiment', false);
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            ...mapGetters('data/country', [
                'config',
            ]),
            src() {
                if (this.requiresGameLaunch) {
                    return this.generatedSrc;
                }

                const baseSuperSpinUrl = getSuperSpinUrl(this.superSpinExperiment);
                return this.user ? `${baseSuperSpinUrl}?a=${this.user.userId}` : '';
            },
            iFrameStyle() {
                if (isMobileLayout() || isMobileDevice()) {
                    return {};
                }
                return {
                    height: `${this.iFrameHeight}px`,
                };
            },
            requiresGameLaunch() {
                return !!shellLocalConfig.superSpinGameLaunch;
            },
        },
        watch: {
            async user() {
                if (!this.user) {
                    this.setLoginModal();
                } else if (this.requiresGameLaunch) {
                    this.generatedSrc = await new FreeToPlayService().launchGame(this.user.sessionId, 'honey-daily-spin');
                }
            },
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'pushModal',
                'closeModal',
            ]),
            setLoginModal() {
                this.setModal(this.loginModal);
            },
            pushLoginModal() {
                this.closeModal();
                this.pushModal(this.loginModal);
            },
            setMessageModal() {
                this.pushModal({
                    code: modalCodes.superSpinMessageModal,
                    data: {
                        openLoginModal: this.pushLoginModal,
                    },
                    afterClose: this.landingRedirect,
                });
            },
            landingRedirect() {
                this.$router.push({ name: RouteName.App.Home });
            },
            processIFrameUpdate(update) {
                if (update.height) {
                    this.iFrameHeight = update.height;
                }
            },
            messageEventListener(event) {
                const expectedOrigin = getIFrameOrigin(getSuperSpinUrl(this.superSpinExperiment));
                if (event.origin !== expectedOrigin) {
                    return;
                }
                const update = parseSuperSpinMessage(event.data);
                this.processIFrameUpdate(update);
            },
        },
        beforeDestroy() {
            if (this.messageListener) {
                window.removeEventListener('message', this.messageEventListener);
            }
        },
    };
</script>
